import { downloadBlob } from '@src/common/utils/downloadBlob';
import { stringify } from 'csv-stringify/browser/esm';

export type Column = { key: string; header: string };

export const CsvExporter = {
  exportData: async (data: unknown[], columns: Column[], fileName?: string) => {
    try {
      const csv = await stringifyAsync(data, columns);
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const name =
        fileName ?? 'Export_' + new Date().toISOString().slice(0, 10);
      downloadBlob(blob, name);
    } catch (e) {
      throw e instanceof Error ? e : new Error(String(e));
    }
  },
};

function stringifyAsync(data: unknown[], columns: Column[]): Promise<string> {
  return new Promise((resolve, reject) => {
    stringify(data, { header: true, columns }, (err, output) => {
      if (err) return reject(new Error('CsvExporter: CSV generation failed.'));
      resolve(output);
    });
  });
}
